import React, { useState, memo, useCallback } from 'react';
import { FilePicker, Text } from '@redlink/components/atoms';
import { ImageUploaderItem } from '@redlink/components/molecules';
import { useMutation, uploadQuery } from '@redlink/services';
import { createUseStyle } from '@redlink/assets/styles';
import { useLocale } from '@redlink/assets/locale';

export const ImageUploader = memo(
  ({ style, disabled = false, title, onUpload, value, thumbnale }) => {
    const { styles } = useStyle();
    const { dictionary } = useLocale();
    const [status, setStatus] = useState(
      value ? ImageUploaderItem.status.selected : ImageUploaderItem.status.none
    );
    const [selectedImageName, setSelectedImageName] = useState(value);
    const [progress, setProgress] = useState(0);

    const [upload] = useMutation(uploadQuery, {
      done: async ({ Upload: { id, thumbnailUrl } }) => {
        onUpload && onUpload({ id, thumbnailUrl });
      },
      failed: () => {
        setStatus(ImageUploaderItem.status.none);
        setSelectedImageName('');
      },
      context: {
        fetchOptions: {
          useUpload: true,
          onProgress: (ev) => {
            setProgress((ev.loaded / ev.total) * 100);
          },
          onAbortPossible: () => {
            setStatus(ImageUploaderItem.status.selected);
          },
        },
      },
    });

    const onChange = useCallback(
      ([file]) => {
        if (file) {
          setStatus(ImageUploaderItem.status.busy);
          setSelectedImageName(file.name);
          upload({ file });
        }
      },
      [upload]
    );

    const onRemove = useCallback(() => {
      setStatus(ImageUploaderItem.status.none);
      setSelectedImageName('');
      onUpload && onUpload(null);
    }, [onUpload]);

    return (
      <FilePicker style={style} {...{ disabled, onChange }}>
        <Text style={styles.placeholderText}>{title}</Text>
        <ImageUploaderItem
          placehoder={dictionary.notSelected}
          {...{ status, onRemove, progress, thumbnale }}
          text={selectedImageName}
        />
      </FilePicker>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  placeholderText: {
    flex: 1,
    fontSize: 12,
    color: colors.gray21,
    textAlign: 'left',
    marginTop: 3,
  },
}));
